export const BREAKPOINT_SM = "650px";
export const LOGO_TEXT = "aigen aliens";
